interface HuntRatingBarProps {
  score: number; // 0-100
}

type QualityRating = 'poor' | 'fair' | 'good' | 'prime';

function getRating(score: number): QualityRating {
  if (score >= 80) return 'prime';
  if (score >= 60) return 'good';
  if (score >= 40) return 'fair';
  return 'poor';
}

function getLitCount(rating: QualityRating): number {
  switch (rating) {
    case 'prime': return 3;
    case 'good': return 3;
    case 'fair': return 2;
    case 'poor': return 1;
  }
}

export function HuntRatingBar({ score }: HuntRatingBarProps) {
  const rating = getRating(score);
  const litCount = getLitCount(rating);
  const isPrime = rating === 'prime';

  const litColor = isPrime ? '#e08a3d' : '#c8651a';
  const unlitColor = '#3d3a35';

  return (
    <div
      data-testid="hunt-rating-bar"
      data-quality={rating}
      className="flex items-center gap-[3px]"
      aria-label={`Hunt rating: ${rating}`}
    >
      {[0, 1, 2].map((i) => {
        const isLit = i < litCount;
        return (
          <div
            key={i}
            data-lit={isLit ? 'true' : 'false'}
            style={{
              backgroundColor: isLit ? litColor : unlitColor,
              width: '14px',
              height: '6px',
              borderRadius: '2px',
            }}
            aria-hidden="true"
          />
        );
      })}
    </div>
  );
}
